module.exports = __webpack_public_path__ + "img/mTicket.24639ffc.svg";